import React, { useState, useEffect } from 'react';
import PlayFeedSidebar from './PlayFeedSidebar';
import PlayFeedGrid from './PlayFeedGrid';
import PlayFeedWatchView from './PlayFeedWatchView';
import { Menu, SlidersHorizontal } from 'lucide-react';
// ⚠️ ATENÇÃO: Ajusta este caminho para onde estiver o teu supabaseClient.ts
// Ex: import { supabase } from '../../supabaseClient'; ou import { supabase } from '../../../supabaseClient';
import { supabase } from '../../../../../supabaseClient'; 

export default function PlayFeedMain() {
  const [activeCategory, setActiveCategory] = useState('Tudo');
  const [activeVideo, setActiveVideo] = useState<any | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Estados de Paginação e Inteligência para o Supabase
  const [videos, setVideos] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0); // Supabase começa no índice 0
  const [hasMore, setHasMore] = useState(true);

  // 🎯 NOVO: Captura o clique da notificação lendo o ID na URL e abre o vídeo exato!
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const videoId = params.get('v');
    
    if (videoId) {
      const fetchNotifiedVideo = async () => {
        const { data, error } = await supabase
          .from('videos')
          .select('*')
          .eq('id', videoId)
          .single();
          
        if (data && !error) {
          setActiveVideo(data); // Abre o player imediatamente com o vídeo da notificação
        }
      };
      fetchNotifiedVideo();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 🛡️ FUNÇÃO QUE BUSCA DO SUPABASE EM LOTES REAIS (PAGINAÇÃO)
  const fetchVideos = async (pageIndex: number, categoryFiltro: string, isNewCategory: boolean) => {
    setLoading(true);
    
    // Paginação de 20 em 20 vídeos
    const from = pageIndex * 20;
    const to = from + 19;

   let query = supabase
  .from('videos')
  .select('*')
  .in('post_type', ['feed', 'app_movel']) // 👈 Aceita tanto o feed quanto os vídeos do painel ShortsPublisher
  .eq('is_short', false)   // 🚨 A PROTEÇÃO: Ignora todos os Shorts verticais da tela web!
  .order('created_at', { ascending: false })
  .range(from, to);

    // Se escolheu uma categoria (e não 'Tudo'), aplica filtro
    // Se escolheu uma categoria (e não 'Tudo'), aplica filtro flexível
    if (categoryFiltro && categoryFiltro !== 'Tudo') {
      if (categoryFiltro === 'filme') {
        query = query.or('category.ilike.%filme%,category.ilike.%cinema%,category.ilike.%acao%,category.ilike.%terror%');
      } else {
        query = query.ilike('category', `%${categoryFiltro}%`);
      }
    }

    const { data, error } = await query;

    if (error) {
      console.error("Erro ao buscar vídeos do Supabase:", error);
      setLoading(false);
      return;
    }

    if (data) {
      // 🎲 Se estiver na categoria "Tudo" (Início), embaralhamos a lista para ficar aleatória!
      let finalData = data;
      if (categoryFiltro === 'Tudo' || !categoryFiltro) {
        finalData = [...data].sort(() => Math.random() - 0.5);
      }

      // Se vierem menos de 20, não há mais páginas
      setHasMore(data.length === 20);

      if (isNewCategory) {
        setVideos(finalData); // 👈 Usa os dados embaralhados na primeira carga da categoria
      } else {
        setVideos(prev => [...prev, ...finalData]);
      }
    }
    
    setLoading(false);
  };

  // Dispara a busca sempre que a categoria mudar
  useEffect(() => {
    setPage(0);
    fetchVideos(0, activeCategory, true);
  }, [activeCategory]);

  // Função para carregar o próximo lote de vídeos
  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVideos(nextPage, activeCategory, false);
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      width: '100%', 
      height: 'calc(100vh - 80px)', /* Mantém a altura exata da tela */
      overflow: 'hidden', /* Continua a travar a página para o menu ficar 100% fixo */
      backgroundColor: '#000', 
      color: '#fff', 
      position: 'relative' 
    }}>
      {/* Barra de Filtro / Hambúrguer exclusiva para Telemóvel */}
      {isMobile && !activeVideo && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 20px', backgroundColor: '#0a0a0a', borderBottom: '1px solid rgba(255,255,255,0.08)'
        }}>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(255,255,255,0.08)',
              border: 'none', color: '#fff', padding: '8px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold'
            }}
          >
            <SlidersHorizontal size={16} color="#E50914" />
            <span>Categorias: {activeCategory === 'Tudo' ? 'Início' : activeCategory}</span>
          </button>
        </div>
      )}

      <div style={{ display: 'flex', flex: 1, width: '100%', position: 'relative' }}>
        {!activeVideo ? (
          <>
            <PlayFeedSidebar 
              activeCategory={activeCategory} 
              onSelectCategory={setActiveCategory}
              isOpenMobile={isMobileMenuOpen}
              onCloseMobile={() => setIsMobileMenuOpen(false)}
            />
            <PlayFeedGrid 
              videos={videos} 
              activeCategory={activeCategory} 
              onSelectVideo={setActiveVideo}
              loading={loading}
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
            />
          </>
        ) : (
          <PlayFeedWatchView 
            video={activeVideo} 
            onBack={() => setActiveVideo(null)} 
            relatedVideos={videos.filter(v => (v.id || v._id) !== (activeVideo.id || activeVideo._id)).slice(0, 5)} 
            onSelectVideo={setActiveVideo}
          />
        )}
      </div>

    </div>
  );
}